import SignUpWithProductsCardsHomepageFirstFoldConfig from "./sign-up-with-products-cards-homepage-first-fold-config";
import SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig from "./sign-up-with-products-cards-homepage-first-fold-advanced-config";
import dynamic from "next/dynamic";
const SignUpWithProductsCardsHomepageFirstFoldComponent = dynamic(()=>import("./sign-up-with-products-cards-homepage-first-fold-component"));
export default {
    SignUpWithProductsCardsHomepageFirstFoldComponent,
    SignUpWithProductsCardsHomepageFirstFoldConfig,
    SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig
};
